// import React, { useEffect, useState } from "react";
// import api from "../api";
// import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, LineChart, Line } from "recharts";

// export default function Analytics() {
//   const [summary, setSummary] = useState({});
//   const [peakHours, setPeakHours] = useState([]);
//   const [tables, setTables] = useState([]);
//   const [items, setItems] = useState([]);

// //   const fetchData = async () => {
// //     const res = await api.get("/analytics/full");
// //     setSummary(res.data.summary);
// //     setPeakHours(res.data.peakHours);
// //     setTables(res.data.tablePerformance);
// //     setItems(res.data.itemIngredientData);
// //   };

// const fetchData = async () => {
//   try {
//     const res = await api.get("/analytics/full");
//     console.log("Analytics API response:", res.data); // <--- check this in browser console
//     setSummary(res.data.summary);
//     setPeakHours(res.data.peakHours);
//     setTables(res.data.tablePerformance);
//     setItems(res.data.itemIngredientData);
//   } catch (err) {
//     console.error("Failed to fetch analytics:", err);
//   }
// };


//   useEffect(() => { fetchData(); }, []);

//   return (
//     <div style={{ padding: 20 }}>
//       <h2>Summary</h2>
//       <p>Total Revenue: ₹{summary?.totalRevenue || 0}</p>
//       <p>Total Orders: {summary?.totalOrders || 0}</p>

//       <h2>Peak Hours</h2>
//       <ResponsiveContainer width="100%" height={300}>
//         <LineChart data={peakHours}>
//           <XAxis dataKey="hour" label={{ value: "Hour", position: "insideBottom" }} />
//           <YAxis />
//           <Tooltip />
//           <Line type="monotone" dataKey="revenue" stroke="#ff7300" />
//         </LineChart>
//       </ResponsiveContainer>

//       <h2>Table Performance</h2>
//       <ResponsiveContainer width="100%" height={300}>
//         <BarChart data={tables}>
//           <XAxis dataKey="tableName" />
//           <YAxis />
//           <Tooltip />
//           <Bar dataKey="revenue" fill="#8884d8" />
//         </BarChart>
//       </ResponsiveContainer>

//       <h2>Item & Ingredient Usage</h2>
//       {items.map(item => (
//         <div key={item.itemName} style={{ marginBottom: 20 }}>
//           {/* <h4>{item.itemName}</h4> */}
//           <ResponsiveContainer width="100%" height={200}>
//             <BarChart data={item.ingredients}>
//               <XAxis dataKey="name" />
//               <YAxis />
//               <Tooltip />
//               <Bar dataKey="qtyUsed" fill="#82ca9d" />
//             </BarChart>
//           </ResponsiveContainer>
//         </div>
//       ))}
//     </div>
//   );
// }


import React, { useEffect, useState, useCallback, memo } from "react";
import api from "../api";
import { 
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, 
  LineChart, Line 
} from "recharts";

// Memoized chart for each item to prevent unnecessary re-renders
const ItemChart = memo(({ item }) => (
  <div key={item.itemName} style={{ marginBottom: 20 }}>
    <ResponsiveContainer width="100%" height={200}>
      <BarChart data={item.ingredients}>
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Bar dataKey="qtyUsed" fill="#82ca9d" />
      </BarChart>
    </ResponsiveContainer>
  </div>
));

export default function Analytics() {
  const [data, setData] = useState({
    summary: {},
    peakHours: [],
    tables: [],
    items: [],
  });

  // useCallback ensures the function reference stays the same
  const fetchData = useCallback(async () => {
    try {
      const res = await api.get("/analytics/full");
      setData({
        summary: res.data.summary,
        peakHours: res.data.peakHours,
        tables: res.data.tablePerformance,
        items: res.data.itemIngredientData,
      });
    } catch (err) {
      console.error("Failed to fetch analytics:", err);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const { summary, peakHours, tables, items } = data;

  return (
    <div style={{ padding: 20 }}>
      <h2>Summary</h2>
      <p>Total Revenue: ₹{summary?.totalRevenue || 0}</p>
      <p>Total Orders: {summary?.totalOrders || 0}</p>

      <h2>Peak Hours</h2>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={peakHours}>
          <XAxis dataKey="hour" label={{ value: "Hour", position: "insideBottom" }} />
          <YAxis />
          <Tooltip />
          <Line type="monotone" dataKey="revenue" stroke="#ff7300" />
        </LineChart>
      </ResponsiveContainer>

      <h2>Table Performance</h2>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={tables}>
          <XAxis dataKey="tableName" />
          <YAxis />
          <Tooltip />
          <Bar dataKey="revenue" fill="#8884d8" />
        </BarChart>
      </ResponsiveContainer>

      <h2>Item & Ingredient Usage</h2>
      {items.map(item => (
        <ItemChart key={item.itemName} item={item} />
      ))}
    </div>
  );
}
